import React, { useState, useEffect, useCallback, useRef } from 'react';

export const WebViewManagerContext = React.createContext(undefined);

// listeners:
//      broadcast-udp: (port, data)
//      unicast-udp: (port, address, data)
//      listen-udp: (port)
//      got-udp: (port, data)
//      start-esptouch-v1: (ssid, password, deviceCount, mode) | mode: 'broadcast' or 'multicast'
//      request-push-token: ()
//      got-push-token: (token)
//
// webViewState:
//      supportUDP
//      supportESPTouchV1

const _addListener = function (listeners, key, callback) {
    if (listeners[key] === undefined)
        listeners[key] = [];
    listeners[key].push(callback);
};
const _removeListener = function (listeners, key, callback) {
    if (listeners[key] !== undefined) {
        const index = listeners[key].indexOf(callback);
        if (index > -1) {
            listeners[key].splice(index, 1);
        }
    }
};
const _notify = function (listeners, key, ...data) {
    if (listeners[key] !== undefined) {
        for (let i = 0; i < listeners[key].length; i++) {
            const callback = listeners[key][i];
            try {
                callback(...data);
            } catch (error) {
                console.error("webViewManager.notify:", key, error);
            }
        }
    } else {
        console.info("webViewManager.notify: no listeners for key", key);
    }
};

export function WebViewManagerContextProvider(props) {
    const [webViewState, setWebViewState] = useState({});
    const listeners = useRef({});

    const addListener = useCallback((...args) => {
        _addListener(listeners.current, ...args)
    }, []);
    const removeListener = useCallback((...args) => {
        _removeListener(listeners.current, ...args)
    }, []);
    const notify = useCallback((...args) => {
        _notify(listeners.current, ...args)
    }, []);

    useEffect(() => {
        window.WebViewManager = {
            addListener: (...args) => {
                _addListener(listeners.current, ...args)
            },
            removeListener: (...args) => {
                _removeListener(listeners.current, ...args)
            },
            notify: (...args) => {
                _notify(listeners.current, ...args)
            },
            setWebViewState: (arg) => {
                setWebViewState(arg)
            }
        };
    }, []);

    return (
        <WebViewManagerContext.Provider value={
            {
                webViewState,
                addListener, removeListener, notify
            }}>
            {props.children}
        </WebViewManagerContext.Provider>
    )
}

// const wm = useContext(WebViewManagerContext);

// (function () {
//     const checkInterval = 1000;
//     const timer = setInterval(() => {
//         if (window.WebViewManager) {
//             if (window.WebViewManager.setWebViewState) {
//                 clearInterval(timer); // Stops the loop immediately
//                 window.WebViewManager.setWebViewState({
//                     supportUDP: true,
//                     supportESPTouchV1: true
//                 });
//             }
//         }
//     }, checkInterval);
// })();
